export default "__VITE_ASSET__0281d9c9__"